module.exports = __webpack_public_path__ + "static/media/Mesa-PortaPendones.428a49f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Mesa-PortaPendones.jpg
// module id = 143
// module chunks = 0